export default __webpack_public_path__ + "static/clusterbuild3-a2a996af76cffc8e4f711550cdaf96d7.png";